export default "__VITE_ASSET__BzEox_ZB__"